webpackJsonp([212839066777427],{

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(30));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(23));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(27));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(28));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(22));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(79));
	
	var _reactHelpers = __webpack_require__(112);
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      justifyContent: 'flex-start',
	      alignItems: 'center',
	      position: 'relative',
	      textDecoration: 'none',
	      width: '100%',
	      boxSizing: 'border-box',
	      textAlign: 'left'
	    },
	    container: {
	      position: 'relative'
	    },
	    focusVisible: {
	      backgroundColor: theme.palette.action.hover
	    },
	    default: {
	      paddingTop: 12,
	      paddingBottom: 12
	    },
	    dense: {
	      paddingTop: theme.spacing.unit,
	      paddingBottom: theme.spacing.unit
	    },
	    disabled: {
	      opacity: 0.5
	    },
	    divider: {
	      borderBottom: "1px solid ".concat(theme.palette.divider),
	      backgroundClip: 'padding-box'
	    },
	    gutters: theme.mixins.gutters(),
	    button: {
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: theme.palette.action.hover,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	    secondaryAction: {
	      // Add some space to avoid collision as `ListItemSecondaryAction`
	      // is absolutely positionned.
	      paddingRight: theme.spacing.unit * 4
	    }
	  };
	};
	
	exports.styles = styles;
	
	var ListItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(ListItem, _React$Component);
	
	  function ListItem() {
	    (0, _classCallCheck2.default)(this, ListItem);
	    return (0, _possibleConstructorReturn2.default)(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(ListItem, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        dense: this.props.dense || this.context.dense || false
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          button = _props.button,
	          childrenProp = _props.children,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          componentProp = _props.component,
	          ContainerComponent = _props.ContainerComponent,
	          _props$ContainerProps = _props.ContainerProps;
	      _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
	      var ContainerClassName = _props$ContainerProps.className,
	          ContainerProps = (0, _objectWithoutProperties2.default)(_props$ContainerProps, ["className"]),
	          dense = _props.dense,
	          disabled = _props.disabled,
	          disableGutters = _props.disableGutters,
	          divider = _props.divider,
	          focusVisibleClassName = _props.focusVisibleClassName,
	          other = (0, _objectWithoutProperties2.default)(_props, ["button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName"]);
	      var isDense = dense || this.context.dense || false;
	
	      var children = _react.default.Children.toArray(childrenProp);
	
	      var hasAvatar = children.some(function (value) {
	        return (0, _reactHelpers.isMuiElement)(value, ['ListItemAvatar']);
	      });
	      var hasSecondaryAction = children.length && (0, _reactHelpers.isMuiElement)(children[children.length - 1], ['ListItemSecondaryAction']);
	      var className = (0, _classnames.default)(classes.root, isDense || hasAvatar ? classes.dense : classes.default, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.gutters, !disableGutters), (0, _defineProperty2.default)(_classNames, classes.divider, divider), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.button, button), (0, _defineProperty2.default)(_classNames, classes.secondaryAction, hasSecondaryAction), _classNames), classNameProp);
	      var componentProps = (0, _objectSpread2.default)({
	        className: className,
	        disabled: disabled
	      }, other);
	      var Component = componentProp || 'li';
	
	      if (button) {
	        componentProps.component = componentProp || 'div';
	        componentProps.focusVisibleClassName = (0, _classnames.default)(classes.focusVisible, focusVisibleClassName);
	        Component = _ButtonBase.default;
	      }
	
	      if (hasSecondaryAction) {
	        // Use div by default.
	        Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.
	
	        if (ContainerComponent === 'li') {
	          if (Component === 'li') {
	            Component = 'div';
	          } else if (componentProps.component === 'li') {
	            componentProps.component = 'div';
	          }
	        }
	
	        return _react.default.createElement(ContainerComponent, (0, _extends2.default)({
	          className: (0, _classnames.default)(classes.container, ContainerClassName)
	        }, ContainerProps), _react.default.createElement(Component, componentProps, children), children.pop());
	      }
	
	      return _react.default.createElement(Component, componentProps, children);
	    }
	  }]);
	  return ListItem;
	}(_react.default.Component);
	
	ListItem.propTypes =  false ? {
	  /**
	   * If `true`, the list item will be a button (using `ButtonBase`).
	   */
	  button: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * The container component used when a `ListItemSecondaryAction` is rendered.
	   */
	  ContainerComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Properties applied to the container element when the component
	   * is used to display a `ListItemSecondaryAction`.
	   */
	  ContainerProps: _propTypes.default.object,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * If `true`, a 1px light border is added to the bottom of the list item.
	   */
	  divider: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string
	} : {};
	ListItem.defaultProps = {
	  button: false,
	  ContainerComponent: 'li',
	  dense: false,
	  disabled: false,
	  disableGutters: false,
	  divider: false
	};
	ListItem.contextTypes = {
	  dense: _propTypes.default.bool
	};
	ListItem.childContextTypes = {
	  dense: _propTypes.default.bool
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItem'
	})(ListItem);
	
	exports.default = _default;

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItem.default;
	  }
	});
	
	var _ListItem = _interopRequireDefault(__webpack_require__(125));

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(30));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(22));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      marginRight: theme.spacing.unit * 2,
	      color: theme.palette.action.active,
	      flexShrink: 0
	    }
	  };
	};
	/**
	 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
	 */
	
	
	exports.styles = styles;
	
	function ListItemIcon(props) {
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className"]);
	  return _react.default.cloneElement(children, (0, _objectSpread2.default)({
	    className: (0, _classnames.default)(classes.root, classNameProp, children.props.className)
	  }, other));
	}
	
	ListItemIcon.propTypes =  false ? {
	  /**
	   * The content of the component, normally `Icon`, `SvgIcon`,
	   * or a `@material-ui/icons` SVG icon element.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : {};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemIcon'
	})(ListItemIcon);
	
	exports.default = _default;

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemIcon.default;
	  }
	});
	
	var _ListItemIcon = _interopRequireDefault(__webpack_require__(229));

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(23));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(22));
	
	var _Typography = _interopRequireDefault(__webpack_require__(20));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      flex: '1 1 auto',
	      minWidth: 0,
	      padding: "0 ".concat(theme.spacing.unit * 2, "px"),
	      '&:first-child': {
	        paddingLeft: 0
	      }
	    },
	    inset: {
	      '&:first-child': {
	        paddingLeft: theme.spacing.unit * 7
	      }
	    },
	    dense: {
	      fontSize: theme.typography.pxToRem(13)
	    },
	    primary: {
	      '&$textDense': {
	        fontSize: 'inherit'
	      }
	    },
	    secondary: {
	      '&$textDense': {
	        fontSize: 'inherit'
	      }
	    },
	    textDense: {}
	  };
	};
	
	exports.styles = styles;
	
	function ListItemText(props, context) {
	  var _classNames3;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      disableTypography = props.disableTypography,
	      inset = props.inset,
	      primaryProp = props.primary,
	      secondaryProp = props.secondary,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "secondary"]);
	  var dense = context.dense;
	  var primary = primaryProp != null ? primaryProp : children;
	
	  if (primary != null && !disableTypography) {
	    primary = _react.default.createElement(_Typography.default, {
	      variant: "subheading",
	      className: (0, _classnames.default)(classes.primary, (0, _defineProperty2.default)({}, classes.textDense, dense)),
	      component: "span"
	    }, primary);
	  }
	
	  var secondary = secondaryProp;
	
	  if (secondary != null && !disableTypography) {
	    secondary = _react.default.createElement(_Typography.default, {
	      variant: "body1",
	      className: (0, _classnames.default)(classes.secondary, (0, _defineProperty2.default)({}, classes.textDense, dense)),
	      color: "textSecondary"
	    }, secondary);
	  }
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.dense, dense), (0, _defineProperty2.default)(_classNames3, classes.inset, inset), _classNames3), classNameProp)
	  }, other), primary, secondary);
	}
	
	ListItemText.propTypes =  false ? {
	  /**
	   * Alias for the `primary` property.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the children won't be wrapped by a Typography component.
	   * This can be useful to render an alternative Typography variant by wrapping
	   * the `children` (or `primary`) text, and optional `secondary` text
	   * with the Typography component.
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * If `true`, the children will be indented.
	   * This should be used if there is no left avatar or left icon.
	   */
	  inset: _propTypes.default.bool,
	
	  /**
	   * The main content element.
	   */
	  primary: _propTypes.default.node,
	
	  /**
	   * The secondary content element.
	   */
	  secondary: _propTypes.default.node
	} : {};
	ListItemText.defaultProps = {
	  disableTypography: false,
	  inset: false
	};
	ListItemText.contextTypes = {
	  dense: _propTypes.default.bool
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemText'
	})(ListItemText);
	
	exports.default = _default;

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemText.default;
	  }
	});
	
	var _ListItemText = _interopRequireDefault(__webpack_require__(231));

/***/ }),

/***/ 1411:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Hidden = __webpack_require__(162);
	
	var _Hidden2 = _interopRequireDefault(_Hidden);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Button = __webpack_require__(45);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _List = __webpack_require__(228);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(126);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ListItemIcon = __webpack_require__(230);
	
	var _ListItemIcon2 = _interopRequireDefault(_ListItemIcon);
	
	var _SvgIcon = __webpack_require__(93);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	var _ListItemText = __webpack_require__(232);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	var _styles = __webpack_require__(11);
	
	var _fragments = __webpack_require__(46);
	
	var _mapper = __webpack_require__(38);
	
	var _site = __webpack_require__(43);
	
	var _site2 = _interopRequireDefault(_site);
	
	var _blog = __webpack_require__(1411);
	
	var _blog2 = _interopRequireDefault(_blog);
	
	var _metadata = __webpack_require__(42);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _banner = __webpack_require__(67);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _quote = __webpack_require__(68);
	
	var _quote2 = _interopRequireDefault(_quote);
	
	var _footer = __webpack_require__(41);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogPage = function BlogPage(props) {
	  var classes = props.classes;
	
	  var metadata = (0, _mapper.mapMetaData)(props.data.blog);
	  var blog = (0, _mapper.mapBlog)(props.data.blog);
	
	  var all = props.data.all.edges.map(function (post) {
	    return (0, _mapper.mapPost)(post.node);
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_metadata2.default, { data: metadata }),
	    _react2.default.createElement(_banner2.default, { uid: 'blog', title: blog.title, subtitle: blog.subtitle }),
	    _react2.default.createElement(Teaser, { image: blog.featured_bg }),
	    _react2.default.createElement(Focus, { blog: blog.featured_post }),
	    blog.list.map(function (post, index) {
	      return _react2.default.createElement(
	        'div',
	        { key: index },
	        _react2.default.createElement(Content, { post: post })
	      );
	    }),
	    _react2.default.createElement(BlogNav, { all: all, featured: blog.list }),
	    _react2.default.createElement(_footer2.default, { policies: props.data.policies.edges })
	  );
	};
	
	var Teaser = (0, _styles.withStyles)(_site2.default)(function (props) {
	  var classes = props.classes,
	      image = props.image;
	
	
	  return _react2.default.createElement(
	    _Hidden2.default,
	    { xsDown: true },
	    _react2.default.createElement(
	      'div',
	      { className: classes.teaser },
	      _react2.default.createElement(
	        _Grid2.default,
	        { container: true, spacing: 0 },
	        _react2.default.createElement(
	          _Grid2.default,
	          { item: true, xs: 12 },
	          _react2.default.createElement('div', {
	            style: {
	              background: 'url(' + image.src + ')',
	              backgroundPosition: 'center',
	              backgroundSize: 'cover',
	              height: '40vh'
	            }
	          })
	        )
	      )
	    )
	  );
	});
	
	var Focus = (0, _styles.withStyles)(_site2.default)(function (props) {
	  var classes = props.classes,
	      blog = props.blog;
	
	  var LinkButton = function LinkButton(props) {
	    return _react2.default.createElement(_gatsbyLink2.default, _extends({ to: '/blog/' + blog.uid }, props));
	  };
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Hidden2.default,
	      { xsDown: true },
	      _react2.default.createElement(
	        'div',
	        { className: classes.focus },
	        _react2.default.createElement(
	          'div',
	          { className: classes.contents },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(classes.focusFloat, classes.focusFloatBlog) },
	            _react2.default.createElement(
	              _Grid2.default,
	              { container: true, spacing: 40, className: classes.focusText },
	              _react2.default.createElement(
	                _Grid2.default,
	                { item: true, xs: 12 },
	                _react2.default.createElement(
	                  _Typography2.default,
	                  { className: classes.focusSub, gutterBottom: true },
	                  blog.data.title.text
	                ),
	                _react2.default.createElement(
	                  _Typography2.default,
	                  { className: classes.focusText },
	                  blog.data.lead.text
	                ),
	                _react2.default.createElement(
	                  _Button2.default,
	                  {
	                    component: LinkButton,
	                    className: (0, _classnames2.default)(
	                    // classes.postlistLink,
	                    classes.focusLink)
	                  },
	                  'Read more'
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	});
	
	var Content = function Content(props) {
	  var post = props.post;
	
	  return post.type === 'blog_list' ? _react2.default.createElement(PostList, { blogs: post.contents }) : post.type === 'blog_quote' ? _react2.default.createElement(_quote2.default, { quote: post.quote }) : null;
	};
	
	var PostList = (0, _styles.withStyles)(_site2.default)(function (props) {
	  var classes = props.classes,
	      blogs = props.blogs;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.postlist },
	    _react2.default.createElement(
	      'div',
	      { className: classes.contents },
	      _react2.default.createElement(
	        'div',
	        { className: classes.centred },
	        _react2.default.createElement(
	          _Hidden2.default,
	          { xsDown: true },
	          _react2.default.createElement(
	            _Grid2.default,
	            { container: true, spacing: 16 },
	            blogs.map(function (blog, index) {
	              return _react2.default.createElement(
	                _Grid2.default,
	                { key: index, item: true, xs: 6 },
	                _react2.default.createElement(Post, { blog: blog, classes: classes })
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Hidden2.default,
	          { smUp: true },
	          _react2.default.createElement(
	            _Grid2.default,
	            { container: true },
	            _react2.default.createElement(
	              _Grid2.default,
	              { item: true, xs: 12 },
	              blogs.map(function (blog, index) {
	                return _react2.default.createElement(Post, { key: index, blog: blog, classes: classes });
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	});
	
	var Post = function Post(props) {
	  var classes = props.classes,
	      blog = props.blog,
	      index = props.index;
	
	
	  var LinkButton = function LinkButton(props) {
	    return _react2.default.createElement(_gatsbyLink2.default, _extends({ to: '/blog/' + blog.uid }, props));
	  };
	  return _react2.default.createElement(
	    'div',
	    { key: index, className: classes.posts },
	    _react2.default.createElement(
	      _Grid2.default,
	      { container: true, spacing: 40, className: classes.postItem },
	      _react2.default.createElement(
	        _Grid2.default,
	        { item: true, xs: 12 },
	        _react2.default.createElement('div', {
	          className: classes.postThumbnail,
	          style: { backgroundImage: 'url(' + blog.post_bg.src + ')' }
	        })
	      ),
	      _react2.default.createElement(
	        _Grid2.default,
	        { item: true, xs: 12 },
	        _react2.default.createElement(
	          _Typography2.default,
	          { variant: 'title', gutterBottom: true },
	          blog.title.text
	        ),
	        blog.author && _react2.default.createElement(
	          _Typography2.default,
	          { variant: 'caption', className: classes.postAuthor },
	          blog.author.author_name.text
	        ),
	        _react2.default.createElement(
	          _Typography2.default,
	          { variant: 'caption' },
	          blog.published
	        ),
	        _react2.default.createElement(
	          _Typography2.default,
	          { className: classes.postlistText },
	          blog.lead.text
	        )
	      ),
	      _react2.default.createElement(
	        _Grid2.default,
	        { item: true, xs: 12 },
	        _react2.default.createElement(
	          _Button2.default,
	          { component: LinkButton, className: classes.postlistLink },
	          'Read more'
	        )
	      )
	    )
	  );
	};
	
	var BlogNav = (0, _styles.withStyles)(_site2.default)(function (props) {
	  var all = props.all,
	      featured = props.featured,
	      classes = props.classes;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.blogStudyNavItems },
	    _react2.default.createElement(
	      'div',
	      { className: classes.contents },
	      _react2.default.createElement(
	        'div',
	        { className: classes.centred },
	        _react2.default.createElement(
	          _Grid2.default,
	          { container: true, spacing: 40 },
	          _react2.default.createElement(
	            _Grid2.default,
	            { item: true, className: classes.title },
	            _react2.default.createElement(
	              _Typography2.default,
	              { variant: 'headline', className: classes.blogStudyNavTitle },
	              'All Posts'
	            ),
	            all.map(function (item) {
	              var active = false;
	              featured.map(function (list) {
	                if (list.type === 'blog_list') {
	                  list.contents.find(function (x) {
	                    if (x.uid === item.uid) {
	                      active = true;
	                    }
	                  });
	                }
	              });
	              return _react2.default.createElement(
	                _ListItem2.default,
	                { key: item.uid, button: true, component: _gatsbyLink2.default, to: '/blog/' + item.uid },
	                _react2.default.createElement('img', { src: _blog2.default, className: classes.blogStudyNavIcon }),
	                _react2.default.createElement(_ListItemText2.default, {
	                  primary: item.title.text,
	                  secondary: item.author.name == null ? null : item.author.name.text,
	                  classes: {
	                    primary: classes.blogStudyItemHead,
	                    secondary: classes.blogStudyItemSub
	                  }
	                })
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	});
	
	exports.default = (0, _styles.withStyles)(_site2.default)(BlogPage);
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-a8e545e304e34e1655b8.js